import { render } from "./PlaDetObs.vue?vue&type=template&id=1362b671&scoped=true"
import script from "./PlaDetObs.vue?vue&type=script&lang=js"
export * from "./PlaDetObs.vue?vue&type=script&lang=js"

import "@/assets/css/microfono.css?vue&type=style&index=0&id=1362b671&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1362b671"]])

export default __exports__